import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

interface LoginProps {
  onLogin: (modules: { id: number; title: string; url: string }[]) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (data.success) {
        const { user } = data.data;

        onLogin(user.modules);
        localStorage.setItem("userId", `${user.current_role}`);
        if (user.current_role === 1 || user.current_role === 8) {
          navigate("/admin-dashboard");
        /*} else if (user.current_role === 5) {
          navigate("/competitions");*/
        } else {
          navigate("/competitions");
        }

        localStorage.setItem("token", data.data.token);
        localStorage.setItem("user", JSON.stringify(data.data.user));
      } else {
        setError("Invalid email or password.");
      }
    } catch (err) {
      setError("Failed to login. Please try again." + err);
    }
  };

  return (
    <section className="section-2">
      <div className="w-layout-blockcontainer container-main-content w-container">
        <h2>Login</h2>
        <form onSubmit={handleLogin} className="login-form">
          <div className="login-form__mainBox">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
              className="login-input"
            />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              className="login-input"
            />
            <button
              type="submit"
              style={{ color: "#efefef !importtant" }}
              className="login-submitBtn"
            >
              Login
            </button>
          </div>
          {error && <p>{error}</p>}
        </form>
      </div>
    </section>
  );
};

export default Login;
